import React from 'react';

const Icon89154SingleArmChaiseLeft = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <path
      d="M327,207.95h187.85c7.98,0,14.45,6.47,14.45,14.45v369.66h-216.75V222.4c0-7.98,6.47-14.45,14.45-14.45Z"
      transform="translate(841.85 800) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M279.88,207.95h23.49c5.07,0,9.18,4.11,9.18,9.18v250.64c0,5.07-4.11,9.18-9.18,9.18h-32.67V217.12c0-5.07,4.11-9.18,9.18-9.18Z"
      transform="translate(583.25 684.89) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="312.55"
      y="207.95"
      width="216.75"
      height="52.25"
      transform="translate(841.85 468.14) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon89154SingleArmChaiseLeft;
